import { viewTrajectoryRoute } from './viewTrajectoryRoute';

const create = (root: string) => () => {
  return `${root}/create`;
};

export const trajectoriesRoutes = (root: string) => ({
  root,
  create: create(root),
  view: viewTrajectoryRoute(root),
});
